import Plane from '../SVGs/Plane';
import React from 'react';
import {connect} from 'react-redux';
import BankUsageDetail from './BankUsageDetail';
import FamilyPackageUsageDetailsPopUp from '../../AbroadCustomerUsageGraphsBlock/FamilyPackageUsageDetailsPopUp/FamilyPackageUsageDetailsPopUp';
import {useFamilyBundleUsage, familyBundleMapState} from '../../AbroadCustomerUsageGraphsBlock/hooks/useFamilyBundleUsage';

const BankPackage = ({ thisPackage = null, isCurrentCycle = false, cycleStart = '', costumerMobile, familyBundleMemberUsageData, familyBundleCollectiveUsageData }) => {
  const {
    isSubscriberHasFamilyBundleUsageData,
    isFamilyBundleManager,
    popupPackageUsages,
    popupPackageUsagesPrevCycle,
    popupCollectiveUsages,
    popupCollectiveUsagesPrevCycle,
    familyPackageUsagePopup,
    openPopup,
    closePopup,
  } = useFamilyBundleUsage({
    showAllTypes: true,
    SocData: {soc: thisPackage?.soc || '', expirationDate: thisPackage?.packageEndDate || ''},
    costumerMobile,
    familyBundleMemberUsageData,
    familyBundleCollectiveUsageData,
  });

  const subLabel = isFamilyBundleManager ? 'כמה כל מנוי ניצל?' : isSubscriberHasFamilyBundleUsageData ? 'כמה מהחבילה ניצלתי?' : null;

  let returned = '';
  if (thisPackage != null) {
    let expiryDiv = '';
    switch (thisPackage.packageStatus) {
      case 'Expired':
        expiryDiv = <div className='ExpiredPackageWarning'>תוקף החבילה הסתיים</div>;
        break;
      case 'Future':
        expiryDiv = <div className='FuturePackageWarning'>החבילה תיכנס לתוקף ב-{thisPackage.packageStartDate}</div>;
        break;
    }

    let uses = '';
    if (thisPackage.subCategories != null) {
      uses = thisPackage.subCategories.map((c) => {
        let used = c.usedValue;
        if (c.usedUnit != c.usageUnits) used = used + ' ' + c.usedUnit;
        return (
          <BankUsageDetail
            usePercentage={c.usePercentage}
            usageType={c.category}
            units={c.usageUnits}
            used={used}
            total={c.totalUsage}
            key={thisPackage.subCategories.indexOf(c)}
            title={c.title}
          />
        );
      });
    }
    let calendarRender = '';
    if (thisPackage.packageEndDate) {
      calendarRender = <BankUsageDetail usageType='Calendar' used={thisPackage.packageStartDate} total={thisPackage.packageEndDate} />;
    }
    returned = (
      <div className='PackageBody'>
        <div className='BankDetails'>
          <p className='Heading'>{thisPackage.packageName}</p>
          <p className='SubHeading'>{thisPackage.packageExpiry}</p>
          {expiryDiv}
        </div>
        <div className='BankBody'>
          {uses}
          {calendarRender}
          {subLabel && (
            <div className='family-bundle-label' >
              <span className='family-bundle-label-text' onClick={openPopup}>{subLabel}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <>
      {returned}
      <FamilyPackageUsageDetailsPopUp
        showPopUp={familyPackageUsagePopup}
        onClose={closePopup}
        packageUsages={isCurrentCycle ? popupPackageUsages : popupPackageUsagesPrevCycle}
        collectiveUsages={isCurrentCycle ? popupCollectiveUsages : popupCollectiveUsagesPrevCycle}
      />
    </>
  );
};

export default connect(familyBundleMapState)(BankPackage);
